export enum NetworkErrorCode {
  NETWORK_ERROR = 'NETWORK_ERROR',
  HTTP_ERROR = 'HTTP_ERROR',
  BAD_REQUEST_ERROR = 'BAD_REQUEST_ERROR',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
  TIMEOUT_ERROR = 'TIMEOUT_ERROR',
  PARSE_ERROR = 'PARSE_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export enum NetworkErrorName {
  NETWORK_ERROR = 'NetworkError',
  HTTP_ERROR = 'HttpError',
  BAD_REQUEST_ERROR = 'BadRequestError',
  CONNECTION_ERROR = 'ConnectionError',
  TIMEOUT_ERROR = 'TimeoutError',
  PARSE_ERROR = 'ParseError',
}
